import { gettext, ngettext } from '@eventbrite/i18n';
import React from 'react';
import { numberFormatter } from '../../utils/utils';

const monthsToYearsRoundUp = (months: number) => {
    return Math.ceil(months / 12);
};

function getTrustSignalMoreThanOneEventInPeriod(
    numberOfEvents: number,
    timeframeInMonths: number,
) {
    const formattedNumberOfEvents = numberFormatter(numberOfEvents);
    const TextComponent = ({ text }: { text: string }) => (
        <span
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: text }}
        />
    );
    if (timeframeInMonths > 1 && timeframeInMonths <= 11) {
        return (
            <TextComponent
                text={ngettext(
                    '<strong>%(numberOfEvents)s</strong> events in last month',
                    '<strong>%(numberOfEvents)s</strong> events in last %(months)s months',
                    numberOfEvents,
                    {
                        numberOfEvents: formattedNumberOfEvents,
                        months: timeframeInMonths,
                    },
                ).toString()}
            />
        );
    }

    const years = monthsToYearsRoundUp(timeframeInMonths);

    if (years <= 2) {
        return (
            <TextComponent
                text={ngettext(
                    '<strong>%(numberOfEvents)s</strong> events in 1 year',
                    '<strong>%(numberOfEvents)s</strong> events in %(years)s years',
                    years,
                    {
                        numberOfEvents: formattedNumberOfEvents,
                        years,
                    },
                ).toString()}
            />
        );
    }

    if (timeframeInMonths === 0) {
        return (
            <TextComponent
                // Translators: This is showing in the organiser box showing the number of events in the last month.
                text={gettext(
                    '<strong>%(numberOfEvents)s</strong> events in last month',
                    {
                        numberOfEvents: formattedNumberOfEvents,
                    },
                ).toString()}
            />
        );
    }
}

export function getTrustSignalText(
    numberOfEventsAsNumber: number,
    timeframeInMonthsAsNumber: number,
) {
    if (numberOfEventsAsNumber === 1) {
        return <>{gettext('New to Eventbrite')}</>;
    }
    if (numberOfEventsAsNumber > 1) {
        return getTrustSignalMoreThanOneEventInPeriod(
            numberOfEventsAsNumber,
            timeframeInMonthsAsNumber,
        );
    }

    return null;
}

export function removeHtmlTags(input: string) {
    const textWithoutHtml = input.replace(/<[^>]*>/g, '');
    return textWithoutHtml.replace(/\s+/g, ' ').trim();
}

export const calculateTopOffset = () => {
    let isMobile = false;
    if (typeof window !== 'undefined') {
        isMobile = window?.innerWidth <= 768;
    }
    return isMobile;
};
